import {css} from 'lit';

export const autoLogoutTextStyle = css`
    .small {
        margin: 0;
        font: var(--sbkTypographyContentLargeScrBodyRegularXs);
    }
    
    .time {
        display: inline-block;
    }
`;
